import React, { useState } from "react";
import PreConfiguracao from '../PreConfiguracao'
import InicioConfiguracao from '../InicioConfiguracao'
import QuestionarioConfiguracao from '../QuestionarioConfiguracao';
import FimConfiguracao from '../FimConfiguracao'


const GerencimentoQuestionario = ({questionario, setQuestionario}) => {
    
    const [fluxoGerenciamento, setFluxoGerenciamento] = useState('PreConfigQ');
    const [questionarioAtual, setQuestionarioAtual] = useState(questionario);

    return (
        <div>
            {fluxoGerenciamento === 'PreConfigQ' && (
                <PreConfiguracao questionario={questionarioAtual} setQuestionario={setQuestionarioAtual} setFluxoGerenciamento={setFluxoGerenciamento}/>
            )}

            {fluxoGerenciamento === 'InicioConfigQ' && (
                <InicioConfiguracao questionario={questionarioAtual} setQuestionario={setQuestionarioAtual} setFluxoGerenciamento={setFluxoGerenciamento}/>
            )}

            {fluxoGerenciamento === 'ConfigQ' && (
                <QuestionarioConfiguracao questionario={questionarioAtual} setQuestionario={setQuestionarioAtual} setFluxoGerenciamento={setFluxoGerenciamento}/>
            )}

            {fluxoGerenciamento === 'FimConfigQ' && (
                <FimConfiguracao questionario={questionarioAtual} setQuestionario={setQuestionarioAtual} setFluxoGerenciamento={setFluxoGerenciamento}/>
            )}
            
        </div>
    )
}

export default GerencimentoQuestionario